import { Feature } from "ol";
import { Geometry } from "ol/geom";

export enum LayerNameOpts {
    monitor = 'Monitor',
    basemap = 'basemap',
    selectionlayer = 'selectionlayer',
    locations = 'locations',
    measurement = 'measurement',
    networkMap = 'Networkmap',
    arcgisAssets = 'ArcGIS Assets',
}

export enum MonitorSymbolType {
    FlowMonitor = 'FlowMonitor',
    LevelMonitor = 'LevelMonitor',
    RainMonitor = 'RainMonitor',
    H2SMonitor = 'H2SMonitor',
    Other = 'Other',
}

export const SOURCE_CHANGE_EVENT_NAME = 'change:source';
export const LAYER_ADDED_EVENT_NAME = 'add';

export interface MapAutocompleteItem {
    name: string;
    id?: number;
    feat: Feature<Geometry>;
    type: MapAutocompleteItemType;
    layerName: string;
    unchecked: boolean;
}

export enum MapAutocompleteItemType {
    feature = 'feature',
    location = 'location'
}
